import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from '@auth/components/auth-callback/auth-callback.component';
import { LoginPageComponent } from '@auth/components/login-page/login-page.component';
import { RecoverConfirmComponent } from '@auth/components/recover-confirm/recover-confirm.component';
import { RecoverPageComponent } from '@auth/components/recover-page/recover-page.component';
import { RegisterConfirmComponent } from '@auth/components/register-confirm/register-confirm.component';
import { RegisterPageComponent } from '@auth/components/register-page/register-page.component';
import { RouteEntity } from '@core/router/router.entity';
import { NavLockGuard } from '@shared/services';


const routes: Routes = [
    {
        path: RouteEntity.Login,
        component: LoginPageComponent,
        canActivate: [NavLockGuard],
    },
    {
        path: RouteEntity.Register,
        component: RegisterPageComponent,
        canActivate: [NavLockGuard],
    },
    {
        path: RouteEntity.Register + '/' + RouteEntity.Confirm,
        component: RegisterConfirmComponent,
        canActivate: [NavLockGuard],
    },
    {
        path: RouteEntity.Recover,
        component: RecoverPageComponent,
        canActivate: [NavLockGuard],
    },
    {
        path: RouteEntity.Recover + '/' + RouteEntity.Confirm,
        component: RecoverConfirmComponent,
        canActivate: [NavLockGuard],
    },
    {
        path: RouteEntity.AuthCallback,
        component: AuthCallbackComponent,
        canActivate: [NavLockGuard],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
